export default __webpack_public_path__ + "static/media/ConnectFive.8daf4dba1747ef367519e75c3a8f9646.webp";